/** Roles that invite supporting users via Delegation Invite (`/invite`). */
export const DELEGATION_INVITE_ROLES = ['ll', 'vp'];

export const ADMIN_INVITE_NEW_USER_PATH = '/user/invite-new-user';
export const DELEGATION_INVITE_PATH = '/invite';

/** Maps non-menu paths to sidebar menu keys for active-state highlighting. */
export const MENU_PATH_TO_KEY = {
  [DELEGATION_INVITE_PATH]: 'add-users.invite-new-user',
};

export function shouldHideMenuItemForRole(role, key) {
  switch (role) {
    case 'admin':
      return key === 'delegation';
    case 'll':
      return key === 'll' || key === 'request' || key === 'company-invite' || key === 'activelog';
    case 'vp':
      return key === 'll' || key === 'vp' || key === 'company-invite' || key === 'activelog';
    case 'rm':
      return (
        key === 'll' ||
        key === 'vp' ||
        key === 'rm' ||
        key === 'delegation' ||
        key === 'company-invite' ||
        key === 'invite-new-user' ||
        key === 'treeview' ||
        key === 'activelog'
      );
    case 'pm':
      return (
        key === 'll' ||
        key === 'vp' ||
        key === 'rm' ||
        key === 'pm' ||
        key === 'delegation' ||
        key === 'user' ||
        key === 'report' ||
        key === 'company-invite' ||
        key === 'invite-new-user' ||
        key === 'activelog'
      );
    default:
      return false;
  }
}

/**
 * Company roles use the existing Delegation Invite page for "Invite New User".
 * Admins keep the all-companies admin workflow.
 */
export function resolveMenuItemLink(role, item) {
  if (!item?.link) return item?.link;
  if (item.key === 'invite-new-user' && DELEGATION_INVITE_ROLES.includes(role)) {
    return DELEGATION_INVITE_PATH;
  }
  return item.link;
}

export function resolveMenuKeyForPathname(pathname) {
  if (!pathname) return null;
  return MENU_PATH_TO_KEY[pathname] || null;
}

export function pathnameMatchesMenuLink(pathname, link) {
  if (!pathname || !link) return false;
  return pathname === link || pathname.startsWith(`${link}/`);
}
